/**
 * Welchen Zeitraum eine Kalenderansicht tatsächlich zeigt.
 *
 * Eigene Datei mit eigenen Tests, weil hier ein Fehler **unsichtbar** ist: Lädt
 * man weniger, als die Ansicht darstellt, fehlen Schichten ohne jeden Hinweis.
 * Der Plan sieht dann leer aus, wo er voll ist — und niemand stutzt, weil eine
 * leere Zelle im Kalender ein völlig normaler Anblick ist. Genau das ist im
 * Monatsraster passiert, als dort nur die laufende Woche geladen wurde.
 */

/** Montag der Woche, in der das Datum liegt (Ortszeit, ohne Uhrzeit). */
export function mondayOf(value: Date): Date {
  const copy = new Date(value)
  const iso = copy.getDay() === 0 ? 7 : copy.getDay()
  copy.setDate(copy.getDate() - (iso - 1))
  copy.setHours(0, 0, 0, 0)
  return copy
}

export function addDays(value: Date, days: number): Date {
  const copy = new Date(value)
  copy.setDate(copy.getDate() + days)
  return copy
}

/**
 * Datum als `JJJJ-MM-TT` in **Ortszeit**.
 *
 * Nicht `toISOString()`: Das rechnet nach UTC um und liefert in Berlin vor
 * 02:00 den Vortag.
 */
export function isoDate(value: Date): string {
  return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(
    value.getDate(),
  ).padStart(2, '0')}`
}

/**
 * Der Bereich, den ein Monatsraster darstellt.
 *
 * Ein Monatsraster zeigt **volle Wochen**: Es beginnt am Montag der Woche, in
 * der der Erste liegt — also bis zu sechs Tage vor dem Monatsanfang — und läuft
 * über sechs Wochen. Wer nur „Erster bis Letzter" lädt, hat an den Rändern
 * Lücken, und zwar an genau den Tagen, die man beim Blick auf den Monatswechsel
 * zuerst ansieht.
 */
export function monthGridRange(date: Date): { von: Date; bis: Date } {
  const erster = new Date(date.getFullYear(), date.getMonth(), 1)
  const von = mondayOf(erster)
  return { von, bis: addDays(von, 41) }
}

/** Montag bis Sonntag der Woche, in der das Datum liegt. */
export function weekRange(date: Date): { von: Date; bis: Date } {
  const von = mondayOf(date)
  return { von, bis: addDays(von, 6) }
}
